import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface TournamentState {
  selectedTournamentId: string | null;
  rulesAccepted: Record<string, boolean>;
}

const initialState: TournamentState = {
  selectedTournamentId: null,
  rulesAccepted: {},
};

const tournamentSlice = createSlice({
  name: 'tournament',
  initialState,
  reducers: {
    selectTournament(state, action: PayloadAction<string | null>) {
      state.selectedTournamentId = action.payload;
    },
    acceptRules(state, action: PayloadAction<string>) {
      state.rulesAccepted[action.payload] = true;
    },
  },
});

export const { selectTournament, acceptRules } = tournamentSlice.actions;
export default tournamentSlice.reducer;
